export const calcShowBackToTop = () => {
  const viewportHeight = window.document.documentElement.clientHeight
  const contentHeight = Math.max(
    document.body.scrollHeight, document.documentElement.scrollHeight,
    document.body.offsetHeight, document.documentElement.offsetHeight,
    document.body.clientHeight, document.documentElement.clientHeight
  )
  return contentHeight > viewportHeight
}
